export default "__VITE_ASSET__25A2DZn9__"